// ProtectedOnboardingRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ROLES } from '../constants/roles';

interface Props {
  children: React.ReactNode;
}

const ProtectedOnboardingRoute: React.FC<Props> = ({ children }) => {
  const { auth } = useAuth();

  if (!auth.token) {
    return <Navigate to="/login" replace />;
  }

  if (auth.user?.role === ROLES.SUPER_ADMIN) {
    return <>{children}</>;
  }

  if (auth.user?.hasCompletedOnboarding === false) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};

export default ProtectedOnboardingRoute;
